/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react'
import toast from 'react-hot-toast';
import LogoMain from '../assets/img/logo/LogoMain.svg'
import { supabaseClient } from "../config/supabase-clients";
import { useAuth } from '../hooks/useAuth';
import packageJson from '../../package.json';
import { useTranslation } from 'react-i18next';

export const ForgotPassword = () => {
    const { t } = useTranslation();
    const [loginButtonLoading, setLoginButtonLoading] = useState(false);
    const { user, signOut } = useAuth();
    const [success, setSuccess] = useState(false);

    document.title = "Coventia Office | Restablecer contraseña";

    useEffect(() => {
        if (user) {
            window.location.href = "/"
        }
    });
  
    async function handleSubmit(event) {
        event.preventDefault()
        setLoginButtonLoading(true)
        const { data, error } = await supabaseClient.auth.resetPasswordForEmail(event.target.email.value);
        if (error) {
            if (error.status == 400) {
                toast.error(t("El email parece no existir en nuestra base de datos"))
            } else {
                toast.error(t("Ha ocurrido un error inesperado"))
            }
            setLoginButtonLoading(false);
        }
        if (data) {
            setSuccess(true)
            setLoginButtonLoading(false);
        }
    }
  
    return (
    <>
        <section className="bg-gray-50 dark:bg-gray-900 w-full h-screen">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
            <a href="/" className="flex items-center text-2xl font-semibold text-gray-900 dark:text-white">
                <img className="w-36 h-36" src={LogoMain} alt="Logo" />
            </a>
            <div className={"w-full bg-white rounded-lg shadow dark:border mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 " + (success ? "hidden" : "")}>
                <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                    <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                        {t('¿Has olvidado tu contraseña?')}
                    </h1>
                    <p className="text-base font-normal text-gray-500 dark:text-gray-400">
                        {t('¡No te preocupes! ¡Simplemente ingresa tu correo electrónico y te enviaremos un enlace para iniciar sesión!')} 😄
                    </p>
                    <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                            <input type="email" name="email" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="jorge@example.com" required></input>
                        </div>
                        {/* Añadir la clase hidden al primer boton si esta loading y mostrar el segundo */}
                        <button type="submit" className={"w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 " + (loginButtonLoading ? "hidden" : "")}>{t('Enviar')}</button>
                        <button disabled type="button" className={"w-full justify-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center " + (loginButtonLoading ? "" : "hidden")}>
                            <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                            </svg>
                            Estamos trabajando...
                        </button>
                        <button type="button" className="w-full text-white bg-gray-700 hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-5 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700" onClick={() => window.location.href = "/auth/login"}>{t('Volver')}</button>
                    </form>
                </div>
            </div>
            <div className={"w-full bg-white rounded-lg shadow dark:border mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 " + (success ? "" : "hidden")}>
                <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                    <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                        🚀 {t('Fiuuuu ¡Hecho!')}
                    </h1>
                    <p className="text-base font-normal text-gray-500 dark:text-gray-400">
                        {t('Si tu email existe en nuestra base de datos, te enviaremos un correo con un enlace para iniciar sesión')} 😄. {t('Recuerda cambiar tu contraseña desde la sección de configuración de tu perfil')}.
                    </p>
                    <a type="submit" href='/' className={"w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"}>Volver</a>
                </div>
            </div>
            {/* Este texto debe ir en la parte inferior de la pantalla y debe ser gris: Coventia Office v1.0.22.3 */}
            <div className="absolute bottom-0 mb-4">
                <p className="text-gray-500 text-xs">Coventia Office v{packageJson.version}</p>
            </div>
        </div>
        </section>
    </>
    )
}